import type React from 'react';
import { Link } from '@tanstack/react-router';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

interface WhatsAppConnectionUnavailableGuidanceProps {
  /** Whether the user can load integration settings and its address list. */
  canOpenIntegrationsSettings: boolean;
}

/**
 * Renders permission-aware recovery guidance for an unavailable WhatsApp sender.
 * @param props - Permission state controlling whether settings can be linked.
 * @returns Recovery copy with either a settings link or administrator guidance.
 */
export const WhatsAppConnectionUnavailableGuidance: React.FC<
  WhatsAppConnectionUnavailableGuidanceProps
> = ({ canOpenIntegrationsSettings }) => {
  const { t } = useI18n();

  return (
    <div className="space-y-1">
      <Text size="small">
        {t('communications.messageBox.whatsapp.connectionUnavailable')}
      </Text>
      {canOpenIntegrationsSettings ? (
        <Link
          to="/settings/integrations"
          search={(previous) => ({
            phoneVersion: previous.phoneVersion ?? 'v1',
          })}
          className="text-sm underline"
        >
          {t('communications.messageBox.whatsapp.openIntegrations')}
        </Link>
      ) : (
        <Text size="small">
          {t('settings.integrations.whatsapp.recovery.adminRequired')}
        </Text>
      )}
    </div>
  );
};
